import React from 'react';
import logo from "../../assets/images/logo.png";

const TermsOfService = () => {
    return (
        <div className="min-h-screen bg-white py-12 px-6">
            <div className="max-w-screen-2xl mx-auto">
                <div className="flex justify-center mb-8">
                    <a href="/"><img src={logo} className="w-[112px] lg:w-[140px] h-auto" alt="Selzor Logo" /></a>
                </div>

                <div className="flex flex-col items-center">
                    <div className="w-full md:w-4/5 text-justify">
                        <div className="text-justify mt-8">
                            <h2 className="text-2xl font-semibold text-gray-600 mb-4 text-start">
                                Terms of Service
                            </h2>

                            <div className="space-y-6 text-gray-700 leading-relaxed">
                                <div>
                                    <p>
                                        <span className="font-bold">THIS IS AN AGREEMENT</span> between you or the entity that you
                                        represent and <span className="font-bold">Selzor</span>, governing your use of Selzor – a
                                        seamless B2B ordering platform for web and mobile.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Acceptance of the Terms</h3>
                                    <p>
                                        You must be of legal age to enter into a binding agreement in order to accept the Terms.
                                        If you do not agree to the Terms, do not use our service. You can accept the Terms by
                                        checking a checkbox, clicking a button indicating your acceptance, or by actually using
                                        the service.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Description of Service</h3>
                                    <p>
                                        <span className="font-bold">Selzor</span> is a seamless B2B ordering platform for{' '}
                                        <span className="font-semibold">Brands, Distributors, Wholesalers, Dealers,</span> and{' '}
                                        <span className="font-semibold">Retailers</span>. It is offered as a hosted service (SaaS
                                        model) and can be accessed via the Selzor web app at{' '}
                                        <a
                                            href="https://b2b.selzor.com/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 underline"
                                        >
                                            https://b2b.selzor.com/
                                        </a>{' '}
                                        or the Selzor Mobile App (available for both Android and iOS). This service does not
                                        include internet access, which must be obtained separately.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Use of Service</h3>
                                    <p>
                                        Selzor grants you a <span className="font-semibold">non-exclusive, non-transferable, non-sub-licensable</span>, and
                                        limited right to access and use the service through the web or mobile app, subject to
                                        these Terms.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Activation of Service</h3>
                                    <p>
                                        Account activation occurs immediately after sign-up. In rare cases, verification codes (via
                                        mobile or email) may be delayed. We ask for your patience in such cases. Premium features
                                        are activated immediately upon payment. If not, please allow 24 working hours for the
                                        changes to reflect. <span className="font-semibold">There is NO recurring billing</span> under premium plans. Upon expiration,
                                        plans must be renewed manually.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Access of Service</h3>
                                    <p>
                                        You can access the service using the login credentials you set during sign-up. The Selzor
                                        Web App is optimized for the latest versions of Google Chrome, Firefox, and Safari on
                                        Windows, macOS, and Linux. Enable JavaScript and cookies for the best experience. Minimum
                                        mobile app requirements: <span className="font-semibold">iOS 8+</span> and{' '}
                                        <span className="font-semibold">Android 4.4.4+</span>.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Availability of Service</h3>
                                    <p>
                                        Selzor strives to ensure continuous service availability during your subscription period.
                                        Scheduled maintenance may occur at off-peak hours. While Selzor will attempt to notify you
                                        in advance, it is not responsible for any loss or damage (financial or otherwise) due to
                                        downtime, data loss, or interruptions beyond our control. In such cases, subscription time
                                        may be extended.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Obligations & Responsibilities</h3>
                                    <p>
                                        You must not decompile, reverse-engineer, plagiarize, or attempt to obtain the source code
                                        of the service. You are responsible for keeping your credentials secure. Selzor does not
                                        guarantee the quality, accuracy, or legality of your submitted data. The platform is
                                        licensed-not sold-to you. You must not tarnish Selzor’s brand or that of its suppliers.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Use of Name & Logo</h3>
                                    <p>
                                        While licensed to use the service, you may identify yourself as a Selzor customer. Do not
                                        use the Selzor name or logo beyond that without prior written permission.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Promotional Material & Publicity</h3>
                                    <p>
                                        You grant Selzor permission to use your name, company name, and logos in promotional
                                        materials and case studies. To opt out, contact us at{' '}
                                        <span className="font-semibold">support@selzor.com</span>.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Price Changes</h3>
                                    <p>
                                        Selzor reserves the right to modify pricing at any time. Updated prices will be displayed
                                        on the official website or within the app.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Right to Refuse Access</h3>
                                    <p>
                                        Selzor may deny access to the service to any user, for any or no reason, at its sole
                                        discretion.
                                    </p>
                                </div>

                                <div>
                                    <h3 className="text-lg font-semibold mb-2">Termination of Service</h3>
                                    <p>
                                        Selzor may terminate accounts that violate these Terms. Dormant or unused accounts may be
                                        deleted, with notice provided where applicable.
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-500 italic">
                                        Last updated:{' '}
                                        <span className="font-semibold">
                                            {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric', })}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <footer className="w-full mt-16 border-t border-gray-200 pt-6 text-center text-sm text-gray-500">
                © {new Date().getFullYear()} Selzor. All rights reserved.
            </footer>
        </div>
    );
};

export default TermsOfService;